(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["zn-pdp"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__znGallerySwipe) return;
    window.__znGallerySwipe = true;

    // A short sideways swipe on the main photo moves one photo (same fix as Brick Hangar).
    function swallowClick(el) {
      var stop = function (event) {
        event.preventDefault();
        event.stopPropagation();
        el.removeEventListener('click', stop, true);
      };
      el.addEventListener('click', stop, true);
      setTimeout(function () {
        el.removeEventListener('click', stop, true);
      }, 500);
    }

    function bind(slideshow) {
      var scroller = slideshow.querySelector('slideshow-slides');
      if (!scroller || scroller.dataset.znSwipe === '1') return;
      scroller.dataset.znSwipe = '1';
      var next = slideshow.querySelector('.slideshow-control--next');
      var prev = slideshow.querySelector('.slideshow-control--previous');
      var startX = 0;
      var startY = 0;
      var startLeft = 0;
      var tracking = false;

      scroller.addEventListener(
        'touchstart',
        function (event) {
          if (event.touches.length !== 1) {
            tracking = false;
            return;
          }
          tracking = true;
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
          startLeft = scroller.scrollLeft;
        },
        { passive: true }
      );

      scroller.addEventListener(
        'touchend',
        function (event) {
          if (!tracking) return;
          tracking = false;
          var touch = event.changedTouches[0];
          if (!touch) return;
          var dx = touch.clientX - startX;
          var dy = touch.clientY - startY;
          if (Math.abs(dx) < 36 || Math.abs(dx) < Math.abs(dy)) return;
          swallowClick(scroller);
          var button = dx < 0 ? next : prev;
          window.setTimeout(function () {
            if (Math.abs(scroller.scrollLeft - startLeft) > 8) return;
            if (button && !button.disabled) button.click();
          }, 60);
        },
        { passive: true }
      );
    }

    function scan() {
      document.querySelectorAll('.shopify-section:has(.zn-pdp) slideshow-component').forEach(bind);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
    else scan();
    document.addEventListener('shopify:section:load', scan);
  })();
  } catch(e) { console.error(e); }
})();

})();
